import React, { useState } from 'react';
import { Fab, Tooltip, useTheme } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { TicketForm } from '../crm/TicketForm';

export const GlobalHelpButton: React.FC = () => {
  const theme = useTheme();
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  return (
    <>
      <Tooltip
        title="Need Help? Create a Support Ticket"
        placement="left"
        arrow
        sx={{
          '& .MuiTooltip-tooltip': {
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%)'
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#ffffff',
            fontWeight: 600,
            fontSize: '0.875rem',
            borderRadius: '8px',
            boxShadow: theme.palette.mode === 'dark'
              ? '0 4px 20px rgba(0, 0, 0, 0.3)'
              : '0 4px 20px rgba(102, 126, 234, 0.3)',
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)'}`,
          },
          '& .MuiTooltip-arrow': {
            color: theme.palette.mode === 'dark'
              ? '#2a2a2a'
              : '#667eea',
          },
        }}
      >
        <Fab
          color="primary"
          aria-label="help"
          onClick={handleOpenForm}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#ffffff',
            width: 56,
            height: 56,
            boxShadow: theme.palette.mode === 'dark'
              ? '0 4px 20px rgba(102, 126, 234, 0.4)'
              : '0 4px 20px rgba(102, 126, 234, 0.3)',
            border: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)'}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              background: theme.palette.mode === 'dark'
                ? 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)'
                : 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
              transform: 'scale(1.1)',
              boxShadow: theme.palette.mode === 'dark'
                ? '0 8px 30px rgba(102, 126, 234, 0.6)'
                : '0 8px 30px rgba(102, 126, 234, 0.5)',
            },
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        >
          <HelpIcon sx={{ fontSize: 28 }} />
        </Fab>
      </Tooltip>

      <TicketForm open={isFormOpen} onClose={handleCloseForm} />
    </>
  );
}; 